import { render, staticRenderFns } from "./Insight.vue?vue&type=template&id=fc8b1038&scoped=true"
import script from "./Insight.vue?vue&type=script&lang=js"
export * from "./Insight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8b1038",
  null
  
)

export default component.exports